// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"hotel_page_sliderContainer__1DMYj","floatingSearchContainer":"hotel_page_floatingSearchContainer__1FBsd"};